class pdpInfoCard extends HTMLElement {
  constructor() {
    super()
    this.modal = this
    this.modalCard = this.querySelector('[data-pdp-info-modal-card]')
    this.modalContent = this.querySelector('[data-modal-content]')
    this.modalMedia = this.querySelector('[data-modal-media]')
    this.modalImage = this.querySelector('[data-modal-image]')
    this.modalVideo = this.querySelector('[data-modal-video]')
    this.modal_bg = this.querySelector('[data-pdp-info-modal-bg]')
    this.modal_close_button = this.querySelector('[data-modal-close-button]')
    this.modal_open_buttons = document.querySelectorAll('[data-pdp-info-modal-open]')
    this.event_target = ''
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    this.closeMediaTimer = null

    this.init()
  }

  decodeModalContent(value) {
    const bytes = Uint8Array.from(atob(value), (char) => char.charCodeAt(0))
    return new TextDecoder().decode(bytes)
  }

  resetMedia() {
    this.modalImage.classList.add('hidden', 'opacity-0')
    this.modalImage.removeAttribute('src')
    this.modalImage.removeAttribute('width')
    this.modalImage.removeAttribute('height')
    this.modalImage.classList.remove('max-w-[220px]', 'max-h-[140px]')

    this.modalVideo.pause()
    this.modalVideo.removeAttribute('src')
    this.modalVideo.removeAttribute('poster')
    this.modalVideo.removeAttribute('controls')
    this.modalVideo.load()
    this.modalVideo.classList.add('hidden')

    this.modalMedia.style.removeProperty('aspect-ratio')
    this.modalMedia.classList.add('!hidden')
    this.modalMedia.classList.remove('py-10', 'max-lg:py-5')
  }

  showImage(button) {
    this.modalVideo.classList.add('hidden')
    this.modalImage.classList.remove('hidden')
    this.modalImage.classList.add('opacity-0')

    if (button.dataset.modalImageFullWidth === 'true') {
      this.modalImage.classList.remove('max-w-[220px]', 'max-h-[140px]')
      this.modalMedia.classList.remove('py-10', 'max-lg:py-5')
    } else {
      this.modalImage.classList.add('max-w-[220px]', 'max-h-[140px]')
      this.modalMedia.classList.add('py-10', 'max-lg:py-5')
    }

    this.modalImage.src = button.dataset.modalImage
    this.modalImage.width = button.dataset.modalImageWidth
    this.modalImage.height = button.dataset.modalImageHeight
    this.modalMedia.classList.remove('!hidden')
  }

  showVideo(button) {
    this.modalImage.classList.add('hidden')
    this.modalImage.classList.remove('max-w-[220px]', 'max-h-[140px]')
    this.modalMedia.classList.remove('py-10', 'max-lg:py-5')
    this.modalMedia.style.aspectRatio = button.dataset.modalVideoAspect || '1 / 1'
    this.modalVideo.classList.remove('hidden')
    if (button.dataset.modalVideoPoster) {
      this.modalVideo.poster = button.dataset.modalVideoPoster
    }
    this.modalVideo.src = button.dataset.modalVideo
    this.modalMedia.classList.remove('!hidden')

    if (this.prefersReducedMotion) {
      this.modalVideo.controls = true
      return
    }

    const play = this.modalVideo.play()
    if (play && typeof play.catch === 'function') {
      play.catch(() => {
        this.modalVideo.controls = true
      })
    }
  }

  openModal = () => {
    this.modal.classList.add('!visible', '!opacity-100')
    this.modalCard.classList.add('!translate-y-0')

    setTimeout(() => {
      trapFocus(this.modalCard, this.modal_close_button)
    }, 300)
  }

  closeModal = () => {
    this.modalCard.classList.remove('!translate-y-0')
    this.modal.classList.remove('!visible', '!opacity-100')
    this.modalVideo.pause()
    clearTimeout(this.closeMediaTimer)
    this.closeMediaTimer = setTimeout(() => {
      this.resetMedia()
    }, 300)
    removeTrapFocus()
    this.event_target.focus()
  }

  init() {
    this.modal_close_button.addEventListener('click', () => {
      this.closeModal()
    })

    this.modal_bg.addEventListener('click', () => {
      this.closeModal()
    })

    this.modal_open_buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        clearTimeout(this.closeMediaTimer)
        this.resetMedia()

        if (button.dataset.modalVideo) {
          this.showVideo(button)
        } else if (button.dataset.modalImage) {
          this.showImage(button)
        }

        if (button.dataset.modalContent) {
          this.modalContent.innerHTML = this.decodeModalContent(button.dataset.modalContent)
        }

        this.openModal()
        this.event_target = event.target
      })
    })
  }
}
customElements.define('pdp-info-card', pdpInfoCard)
